import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router';
import { clsx } from 'clsx';

// utils
import {
  resolveTitle,
  PUSH_HISTORY_PAGE_TITLE,
  ACCOUNT_PAGE_TITLE,
  CARD_PAGE_TITLE,
} from './utils';

// UI
import Header from '@components/account-header';
import { NotificationProvider } from '@store/notifications';
import Notifications from '@components/notifications-list';

/**
 * Store
 */
import { useAppStore } from '@store/app-store';

// icons
import ArrowIcon from '@assets/icons/arrow-down.svg?react';

// styles
import css from './styles.module.css';

const ROOT_ACCOUNT_PAGES = [
  '/account',
  '/account/',
  '/account/profile',
  '/account/profile/',
];

const AccountLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loadUserData = useAppStore((state) => state.loadUserData);
  const mobileHeaderTitle = resolveTitle(location.pathname);

  useEffect(() => {
    document.body.classList.add('adjust-for-lk-pages');

    return () => {
      document.body.classList.remove('adjust-for-lk-pages');
    };
  }, []);

  useEffect(() => {
    loadUserData();
  }, []);

  const handleGoBack = () => {
    if (
      mobileHeaderTitle === PUSH_HISTORY_PAGE_TITLE ||
      mobileHeaderTitle === ACCOUNT_PAGE_TITLE ||
      mobileHeaderTitle === CARD_PAGE_TITLE
    ) {
      navigate('/account');
      return;
    }

    navigate(-1);
  };

  const isRootAccountPage = ROOT_ACCOUNT_PAGES.includes(location.pathname);

  const isProfilePage = location.pathname.includes('/account/profile');

  return (
    <NotificationProvider>
      <>
        <div
          className={clsx(css.accountLayoutRoot, {
            [css.nonAccountMainPage]: !isRootAccountPage,
            [css.accountMainPage]: isRootAccountPage,
          })}
        >
          <Header
            displayOnMobile={isRootAccountPage && !isProfilePage}
            className={clsx({ [css.acountPageHeader]: isRootAccountPage })}
          />

          <button
            onClick={handleGoBack}
            className={clsx(css.resetButton, css.backLink, {
              [css.hideLink]: isRootAccountPage,
            })}
          >
            <ArrowIcon className={css.backIcon} width={24} height={24} />
            Back
          </button>

          <div
            className={clsx(css.mobileHeader, {
              [css.hideOnAccountPage]: isRootAccountPage && !isProfilePage,
            })}
          >
            <button
              className={clsx(css.resetButton, css.mobileBackButton)}
              onClick={handleGoBack}
            >
              <ArrowIcon className={css.backIcon} width={24} height={24} />
            </button>

            <p className={css.mobileHeaderTitle}>{mobileHeaderTitle}</p>
          </div>

          <main
            className={clsx(css.mainContentArea, {
              [css.accountMainPage]: isRootAccountPage && !isProfilePage,
              [css.profilePage]: isProfilePage,
            })}
          >
            <Outlet />
          </main>
        </div>
        <Notifications />
      </>
    </NotificationProvider>
  );
};

export default AccountLayout;
